/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marker_Position_ScheduledInputs */

const fr_marker_position_scheduled = /** @type {(inputs: Marker_Position_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Position théorique`)
};

const en_marker_position_scheduled = /** @type {(inputs: Marker_Position_ScheduledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheduled position`)
};

/**
* | output |
* | --- |
* | "Scheduled position" |
*
* @param {Marker_Position_ScheduledInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const marker_position_scheduled = /** @type {((inputs?: Marker_Position_ScheduledInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marker_Position_ScheduledInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_marker_position_scheduled(inputs)
	return en_marker_position_scheduled(inputs)
});